import { AdSlot, AdSlotProps, AdBanner as AdBannerAlias } from './AdSlot';

export const AdBanner = AdBannerAlias;
export { AdSlot };
export type { AdSlotProps };
export default AdSlot;
